// Import modules and libraries
import Vue from "vue";
import VueRouter from "vue-router";
import moment from "moment";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import pusherPlugin from './pusherPlugin';
import VueTheMask from 'vue-the-mask'

// Install the plugin globally
Vue.use(VueTheMask)
// Import components
import App from "./App.vue";
import Dashboard from "./components/DashboardPage.vue";
import Search from "./components/SearchPage.vue";
import CompanyForm from './components/Company/CompanyForm.vue';
import Policy from "./components/Policy/PolicyPage.vue";
import PolicyForm from "./components/Policy/PolicyForm.vue";
import PolicyRenew from "./components/Policy/PolicyRenew.vue";
import PolicyNew from "./components/Policy/PolicyNew.vue";
import PoliciesList from "./components/Policy/PoliciesList.vue";
import Aspect from "./components/Aspect/AspectPage.vue";
import AspectNew from "./components/Aspect/AspectNew.vue";
import DocsHome from "./components/Doc/DocsHome.vue";
import DocsForm from "./components/Doc/DocsForm.vue";
import DocsNew from "./components/Doc/DocsNew.vue";
import CannedNotesList from "./components/Note/CannedNotesList.vue";
import CannedNoteForm from "./components/Note/CannedNoteForm.vue";
import TasksHome from "./components/Task/TasksHome.vue";
import TaskForm from "./components/Task/TaskForm.vue";
import Task from "./components/Task/TaskPage.vue";
import AspectForm from "./components/Aspect/AspectForm.vue";
import LoginPage from "./components/Auth/LoginPage.vue";
import LogOut from "./components/Auth/LogOut.vue";
import ResetPassword from "./components/Auth/ResetPassword.vue";
import ResetCode from "./components/Auth/ResetCode.vue";
import Profile from "./components/User/ProfilePage.vue";
import ProfileForm from "./components/User/ProfileForm.vue";
import AdminUsers from "./components/User/AdminUsers.vue";
import AdminUserForm from "./components/User/AdminUserForm.vue";
import MessagesList from "./components/System/MessagesList.vue";
import MessageForm from "./components/System/MessageForm.vue";
import ChatRoom from "./components/Inbox/ChatRoom.vue";
import ChatForm from "./components/Inbox/ChatForm.vue";
import DmForm from "./components/Inbox/DmForm.vue";
import RemindersList from "./components/Reminder/RemindersList.vue";
import UserLogins from "./components/Reports/UserLogins.vue";
import UserSummary from "./components/Reports/UserSummary.vue";
import UserActivity from "./components/Reports/UserActivity.vue";
import UserPolicySummary from "./components/Reports/UserPolicySummary.vue";
import TotalPremiumVolume from "./components/Reports/TotalPremiumVolume.vue";
import linesofcoverageList from "./components/Admin/linesofcoverageList.vue";
import linesofcoverageAdd from "./components/Admin/linesofcoverageAdd.vue";
import linesofcoverageEdit from "./components/Admin/linesofcoverageEdit.vue";
import risktypeList from "./components/Admin/risktypeList.vue";
import risktypeAdd from "./components/Admin/risktypeAdd.vue";
import risktypeEdit from "./components/Admin/risktypeEdit.vue";
import aspectList from "./components/Admin/aspectList.vue";
import exportCSV from "./components/Admin/exportCSV.vue";
import DeletedItems from "./components/System/DeletedItems.vue";
import NotFound from "./components/NotFound.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import SimpleVueValidation from "simple-vue-validator";
import TaskDistribution from "./components/Task/TaskDistribution.vue";
Vue.use(SimpleVueValidation);

// Add font awesome icons to library
library.add(fas, far, fab);

// Register font awesome component
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Use plugins
Vue.use(VueRouter);
Vue.use(CKEditor);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(require('vue-moment'));
Vue.use(pusherPlugin);

// Set up filters
Vue.filter("fullDate", function (value) {
  if (value) {
    return moment(String(value)).format("MMM Do YYYY h:mm a");
  }
});
// Calulate the persons age from their date of birth
Vue.filter("age", function (value) {
 
  if (value) {
    var today = new Date();
    var birthDate = new Date(value);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

})

Vue.filter("money", function (value) {
  if (value > 0) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(0);
  }
});

Vue.filter("onlyDate", function (value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});

Vue.filter("isJson", function (value) {
  if (value) {
    try {
      JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
});

// Set up Vue Router
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: {
        title: "Search",
        description: "",
      }
    },    
    {
      path: "/export/mailing-list",
      name: "export_mailing_list",
      component: exportCSV,
      meta: {
        title: "Export Mailing List",
        description: "",
      }
    },
    {
      path: "/export/policies",
      name: "export_policies",
      component: exportCSV,
      meta: {
        title: "Export Policies",
        description: "",
      }
    },
        
    {
      path: "/report/user-logins",
      name: "user_logins",
      component: UserLogins,
      meta: {
        title: "Recent User Logins",
        description: "",
      }
    },
    {
      path: "/report/user-summary",
      name: "user_summary",
      component: UserSummary,
      meta: {
        title: "Active User Summaries",
        description: "",
      }
    },
    {
      path: "/report/user-activity",
      name: "user_activity",
      component: UserActivity,
      meta: {
        title:  "User Activity",
        description: "",
      }
    },  
    {
      path: "/report/user-policy-summary",
      name: "user_policy_summary",
      component: UserPolicySummary,
      meta: {
        title:  "User Policy Summary",
        description: "",
      }
    },     
    {
      path: "/report/total-premium-volume",
      name: "total_premium_volume",
      component: TotalPremiumVolume,
      meta: {
        title:  "Total Premium Volume",
        description: "",
      }
    },        
    {
      path: "/inbox/message",
      name: "inbox_personal_chat",
      component: ChatRoom,
      meta: {
        title: "Personal Inbox",
        description: "",
      }
    },

    {
      path: "/inbox/message/:id",
      name: "inbox_group_chat",
      component: ChatRoom,
      meta: {
        title: "Group Inbox",
        description: "",
      }
    },
    {
      path: "/inbox/create",
      name: "inbox_create",
      component: ChatForm,
      meta: {
        title: "Create Inbox",
        description: "",
      }
    },
    {
      path: "/inbox/dm/create",
      name: "inbox_dm",
      component: DmForm,
      meta: {
        title: "Create Direct Message",
        description: "",
      }
    },
    {
      path: "/reminders",
      name: "reminders",
      component: RemindersList,
      meta: {
        title: "Reminders",
        description: "",
      }
    },

    {
      path: "/inbox/:id/edit",
      name: "inbox_edit",
      component: ChatForm,
      meta: {
        title: "Create Edit",
        description: "",
      }
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        title: "Hayek Client Portal Dashboard",
        description: "",
      },
    },
    {
      path: "/admin/canned-notes",
      name: "notes_list",
      component: CannedNotesList,
      meta: {
        title: "Canned Notes",
        description: "",
      },
    },     
    {
      path: "/admin/linesofcoverage",
      name: "linesofcoverageList",
      component: linesofcoverageList,
      meta: {
        title: "Lines of Coverage",
        description: "",
      },
    }, 
    {
      path: "/admin/linesofcoverage/new",
      name: "linesofcoverageAdd",
      component: linesofcoverageAdd,
      meta: {
        title: "New Lines of Coverage",
        description: "",
      },
    }, 
    {
      path: "/admin/linesofcoverage/:id/edit",
      name: "linesofcoverageEdit",
      component: linesofcoverageEdit,
      meta: {
        title: "Edit Lines of Coverage",
        description: "",
      },
    }, 
    {
      path: "/admin/risktypes",
      name: "risktypeList",
      component: risktypeList,
      meta: {
        title: "Risk Types",
        description: "",
      },
    }, 
    {
      path: "/admin/risktype/new",
      name: "risktypeAdd",
      component: risktypeAdd,
      meta: {
        title: "New Risk Type",
        description: "",
      },
    }, 
    {
      path: "/admin/risktype/:id/edit",
      name: "risktypeEdit",
      component: risktypeEdit,
      meta: {
        title: "Edit Risk Type",
        description: "",
      },
    },     
    {
      path: "/admin/canned-note/new",
      name: "note_create",
      component: CannedNoteForm,
      meta: {
        title: "New Canned Note",
        description: "",
      },
    }, 
    {
      path: "/admin/canned-note/:id/edit",
      name: "note_form",
      component: CannedNoteForm,
      meta: {
        title: "New Canned Note",
        description: "",
      },
    }, 
    {
      path: "/admin/company",
      name: "admin_company",
      component: CompanyForm,
      meta: {
        title: "Company Settings",
        description: ""
      }
    },

    {
      path: "/admin/system-messages",
      name: "admin_system_messages",
      component: MessagesList,
      meta: {
        title: "System Messages",
        description: ""
      }
    },
    {
      path: "/admin/system-message/new",
      name: "admin_system_message_new",
      component: MessageForm,
      meta: {
        title: "Create System Message",
        description: ""
      }
    },
    {
      path: "/admin/system-message/:id/edit",
      name: "admin_system_message_edit",
      component: MessageForm,
      meta: {
        title: "Edit System Message",
        description: ""
      }
    },
    {
      path: "/admin/deleted-items",
      name: "admin_deleted_items",
      component: DeletedItems,
      meta: {
        title: "Deleted Items",
        description: ""
      }
    },
    {
      path: "/admin/insurance-companies",
      name: "admin_insurance_company",
      component: aspectList,
      meta: {
        title: "Insurance Companies",
        description: ""
      }
    },
    {
      path: "/admin/general-agents",
      name: "admin_general_agent",
      component: aspectList,
      meta: {
        title: "General Agents",
        description: ""
      }
    }, 
    {
      path: "/policies",
      name: "policy_list",
      component: PoliciesList,
      meta: {
        title: "Policy List",
        description: ""
      }
    },           
    {
      path: "/policy/new",
      name: "policy_new",
      component: PolicyNew,
      meta: {
        title: "New Policy",
        description: ""
      }
    },
    {
      path: "/policy/:policy_key",
      name: "policy",
      component: Policy,
      meta: {
        title: "View Policy",
        description: "",
      },
    },
    {
      path: "/policy/:policy_key/edit",
      name: "policy_edit",
      component: PolicyForm,
      meta: {
        title: "Edit Policy",
        description: "",
      },
    },
    {
      path: "/policy/:policy_key/renew",
      name: "policy_renew",
      component: PolicyRenew,
      meta: {
        title: "Policy Renew",
        description: "",
      },
    },
    {
      path: "/aspect/new",
      name: "aspect_new",
      component: AspectNew,
      meta: {
        title: "New Aspect",
        description: "",
      },
    },
    {
      path: "/aspect/:aspect_key/edit",
      name: "aspect_edit",
      component: AspectForm,
      meta: {
        title: "Edit Aspect",
        description: "",
      },
    },
    {
      path: "/aspect/:aspect_key",
      name: "aspect",
      component: Aspect,
      meta: {
        title: "View Aspect",
        description: "",
      },
    },
    {
      path: "/docs",
      name: "docs",
      component: DocsHome,
      meta: {
        title: "Docs",
        description: "",
      },
    },
    {
      path: "/doc/create",
      name: "doc_create",
      component: DocsNew,
      meta: {
        title: "New Doc",
        description: "",
      },
    },    
    {
      path: "/doc/:id",
      name: "doc_edit",
      component: DocsForm,
      meta: {
        title: "Docs",
        description: "",
      },
    },
    {
      path: "/tasks",
      name: "tasks",
      component: TasksHome,
      meta: {
        title: "Tasks",
        description: "",
      },
    },
    {
      path: "/task/new",
      name: "task_new",
      component: TaskForm,
      meta: {
        title: "New Task",
        description: "",
      },
    },
    {
      path: "/tasks/distribution",
      name: "task_distribution",
      component: TaskDistribution,
      meta: {
        title: "Task Distribution",
        description: "",
      },
    },    
    {
      path: "/task/:id/edit",
      name: "task_edit",
      component: TaskForm,
      meta: {
        title: "Edit Task",
        description: "",
      },
    },
    {
      path: "/task/:id",
      name: "task",
      component: Task,
      meta: {
        title: "Task Detail",
        description: "",
      },
    },
    {
      path: "/user/:id",
      name: "profile",
      component: Profile,
      meta: {
        title: "User Profile",
        description: "",
      },
    },
    {
      path: "/profile/edit",
      name: "profile_edit",
      component: ProfileForm,
      meta: {
        title: "Edit Profile",
        description: "",
      },
    },
    {
      path: "/",
      name: "login",
      component: LoginPage,
      meta: {
        title: "Hayek Client Portal Policy",
        description: "",
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: LogOut,
      meta: {
        title: "Hayek Client Portal Policy",
        description: "",
      },
    },
    {
      path: "/reset-password",
      name: "reset_password",
      component: ResetPassword,
      meta: {
        title: "Hayek Client Portal Policy",
        description: "",
      },
    },    
    {
      path: "/reset-code",
      name: "reset_code",
      component: ResetCode,
      meta: {
        title: "Hayek Client Portal Policy",
        description: "",
      },
    },       
    {
      path: "/admin/users",
      name: "admin_users",
      component: AdminUsers,
      meta: { title: "Admin Users", description: "" },
    },
    {
      path: "/admin/user/new",
      name: "admin_user_new",
      component: AdminUserForm,
      meta: { title: "Admin User Create", description: "" },
    },
    {
      path: "/admin/user/:id/edit",
      name: "admin_user",
      component: AdminUserForm,
      meta: { title: "Admin User", description: "" },
    },
    {
      path: "/:catchAll(.*)",
      component: NotFound,
      name: "NotFound",
    },
  ],
});

// Create new Vue instance
new Vue({
  router,
  components: { App },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "IMS";
      },
    },
  },
  render: (h) => h(App),
}).$mount("#app");
